import { render, staticRenderFns } from "./component.vue?vue&type=template&id=6854f328&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"
import style0 from "./component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/projects/pes-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6854f328')) {
      api.createRecord('6854f328', component.options)
    } else {
      api.reload('6854f328', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=6854f328&", function () {
      api.rerender('6854f328', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/resource/component/ad-carousel/component.vue"
export default component.exports